import { Stack } from "@mui/material"
import { AppHeader } from "containers"
import { useEffect } from "react"
import { useSelector } from "react-redux"
import { createSearchParams, Navigate, Route, Routes, useLocation, useNavigate } from "react-router-dom"
import { profileSelector } from "reducers/profileSlice"
import { authRoute, privateRoute } from "routes"

const PrivateLayout = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { isLoggedIn } = useSelector(profileSelector)

  useEffect(() => {
    if (!isLoggedIn) {
      navigate(
        {
          pathname: authRoute.login.url,
          search: createSearchParams({ callbackUrl: location.pathname }).toString(),
        },
        { replace: true },
      )
    }
  }, [isLoggedIn, location.pathname, navigate])

  return (
    <main>
      <AppHeader />
      <Stack
        className="px-4 py-6 sm:px-6"
        sx={{
          height: {
            sm: `calc(100vh - 64px)`,
            xs: `calc(100vh - 56px)`,
          },
        }}
      >
        <Routes>
          {Object.values(privateRoute).map(({ component: Element, path }) => (
            <Route element={<Element />} key={path} path={path} />
          ))}
          <Route element={<Navigate to={privateRoute.home.path} />} path="*" />
        </Routes>
      </Stack>
    </main>
  )
}

export default PrivateLayout
